var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAirplaneStat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.52503 18.075L9.4667 16.4417C9.75837 16.1917 10.2417 16.1917 10.5334 16.4417L12.475 18.075C12.925 18.3 13.475 18.075 13.6417 17.5917L14.0084 16.4833C14.1 16.2167 14.0084 15.825 13.8084 15.625L11.9167 13.725C11.775 13.5917 11.6667 13.325 11.6667 13.1333V10.7583C11.6667 10.4083 11.925 10.2417 12.25 10.375L16.3417 12.1417C16.9834 12.4167 17.5084 12.075 17.5084 11.375V10.3C17.5084 9.74167 17.0917 9.1 16.575 8.88334L11.9167 6.875C11.7834 6.81667 11.6667 6.64167 11.6667 6.49167V3.99167C11.6667 3.20834 11.0917 2.28334 10.3917 1.925C10.1417 1.8 9.85003 1.8 9.60003 1.925C8.90003 2.28334 8.32503 3.21667 8.32503 4V6.5C8.32503 6.65 8.20837 6.825 8.07503 6.88334L3.42503 8.89167C2.90837 9.1 2.4917 9.74167 2.4917 10.3V11.375C2.4917 12.075 3.0167 12.4167 3.65837 12.1417L7.75003 10.375C8.0667 10.2333 8.33337 10.4083 8.33337 10.7583V13.1333C8.33337 13.325 8.22503 13.5917 8.0917 13.725L6.20003 15.625C6.00003 15.825 5.90837 16.2083 6.00003 16.4833L6.3667 17.5917C6.5167 18.075 7.0667 18.3083 7.52503 18.075Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplaneStat);
export default __webpack_public_path__ + "static/media/airplane-stat.4c44456d58d0b27eaa3afa963f1bdebf.svg";
export { ForwardRef as ReactComponent };